import React from 'react'
import { BigTableView, MRDetailsCard } from '../../../_metronic/layout/components/RhEALComponent'

const MRDetails = () => {
    return (
        <>
            <MRDetailsCard cardTitle={'MR Details'} />
            <BigTableView />
        </>
    )
}

export default MRDetails